'use es6';

import ActionTypes from '../actions/ActionTypes';
import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
const DEFAULT_HOME_FILTERS = {
  selectedCategories: ImmutableSet(),
  selectedAwardFilter: 'ALL',
  selectedUserProgressFilter: 'ALL'
};
export const initialAppState = {
  video: {
    autoPlay: false,
    playSpeed: 100
  },
  homeFilters: DEFAULT_HOME_FILTERS,
  productAccess: ImmutableMap(),
  trackIdsRecentlySentToUpwork: [],
  sendToUpworkIsRequesting: false,
  sendToUpworkHasError: false
};
export function App(state = initialAppState, action) {
  switch (action.type) {
    case ActionTypes.SET_VIDEO_PLAY_SPEED:
      return Object.assign({}, state, {
        video: Object.assign({}, state.video, {
          playSpeed: action.playSpeed
        })
      });

    case ActionTypes.TOGGLE_AUTO_PLAY:
      return Object.assign({}, state, {
        video: Object.assign({}, state.video, {
          autoPlay: !state.video.autoPlay
        })
      });

    case ActionTypes.SET_SELECTED_CATEGORIES:
      return Object.assign({}, state, {
        homeFilters: Object.assign({}, state.homeFilters, {
          selectedCategories: action.payload
        })
      });

    case ActionTypes.SET_SELECTED_AWARD_FILTER:
      return Object.assign({}, state, {
        homeFilters: Object.assign({}, state.homeFilters, {
          selectedAwardFilter: action.payload
        })
      });

    case ActionTypes.SET_SELECTED_USER_PROGRESS_FILTER:
      return Object.assign({}, state, {
        homeFilters: Object.assign({}, state.homeFilters, {
          selectedUserProgressFilter: action.payload
        })
      });

    case ActionTypes.CLEAR_ALL_FILTERS:
      return Object.assign({}, state, {
        homeFilters: DEFAULT_HOME_FILTERS
      });

    case ActionTypes.SEND_TO_UPWORK_REQUESTING:
      return Object.assign({}, state, {
        sendToUpworkIsRequesting: true,
        sendToUpworkHasError: false
      });

    case ActionTypes.SEND_TO_UPWORK_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        trackIdsRecentlySentToUpwork: [...state.trackIdsRecentlySentToUpwork, action.payload],
        sendToUpworkIsRequesting: false,
        sendToUpworkHasError: false
      });

    case ActionTypes.SEND_TO_UPWORK_REQUEST_ERROR:
      return Object.assign({}, state, {
        sendToUpworkIsRequesting: false,
        sendToUpworkHasError: true
      });

    case ActionTypes.ALL_CONTENT_RECEIVED:
      {
        return Object.assign({}, state, {
          productAccess: action.payload.get('productAccess')
        });
      }

    default:
      return state;
  }
}